export default __webpack_public_path__ + "static/media/photoInstruct.bd5325ad.png";